<div class="layout horizontal center middle" style="width: 100%; height: 120px; margin-bottom: 16px;">
    <app-flipping-logo height="120px" 
                        width="120px"
            frontImage="./assets/images/login.svg"
            frontImageHeight="100px">
    </app-flipping-logo>
</div>

<!--
PRIMA FASE
-->
<ng-container *ngIf="!submitDone">
    <!--
    ISTRUZIONI
    -->
    <p class="message">{{'SIGN_UP.INSTRUCTIONS'|translate}}</p>
    <app-form-field label="SIGN_UP.FIRST_NAME"
                    [value]="valuesForInput.firstName"
                    [settings]="settings.fieldsSettings.firstName"
                    (modelChange)="updateCurrentValue('firstName',$event)"
                    [specifiedAttributes]="specifiedAttributes.firstName">
    </app-form-field>
    <app-form-field label="SIGN_UP.LAST_NAME"
                    [value]="valuesForInput.lastName"
                    [settings]="settings.fieldsSettings.lastName"
                    (modelChange)="updateCurrentValue('lastName',$event)"
                    [specifiedAttributes]="specifiedAttributes.lastName">
    </app-form-field>
    <div>
        <app-form-field type="EMAIL" 
                        [label]="'SIGN_UP.EMAIL'|translate"
                        [settings]="settings.fieldsSettings.email"
                        [value]="valuesForInput.email"
                        (modelChange)="updateCurrentValue('email',$event)"
                        [specifiedAttributes]="specifiedAttributes.email"
                        (enterPressure)="submit()">
        </app-form-field>
    </div>
    <div class="layout horizontal center middle" *ngIf="requireRecaptcha" style="margin-bottom: 20px;">
        <re-captcha #reCaptcha style="margin-top: 6px;"
            (resolved)="recaptchaToken=$event"
            (error)="onError($event)"
            errorMode="handled"
            siteKey="6Lfom9AaAAAAABwNzIgDQb90pw70CKm7boaKeKoB">
        </re-captcha>
    </div>
    
    <div class="layout horizontal space-between">
        <app-button-set align="left">
            <app-button [label]="'CANCEL'|translate" icon="arrow-left" (click)="cancel()"
                        [disabled]="formSubmitting"></app-button>
        </app-button-set>
        <app-button-set align="right">
            <app-button [label]="'PROCEED'|translate" primary="true" icon="check" [action]="submit.bind(this)" 
                        [disabled]="someErrors || formSubmitting"></app-button>
        </app-button-set>
    </div>
</ng-container>
<!--
SECONDA FASE
-->
<ng-container *ngIf="submitDone">
    <!--
    MESSAGGIO DI FEEDBACK
    -->
    <div [innerHtml]="'SIGN_UP.FEEDBACK'|translate"></div>
</ng-container>